<template>
	<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.5 23.75">
		<path fill="currentColor" d="M11.75 23.75A11.76358 11.76358 0 0 1 0 12a11.63974 11.63974 0 0 1 3.68555-8.54541.74989.74989 0 1 1 1.02929 1.09082A10.15508 10.15508 0 0 0 1.5 12 10.25 10.25 0 0 0 22 12a10.15668 10.15668 0 0 0-3.21484-7.45459.74989.74989 0 0 1 1.02929-1.09082A11.64134 11.64134 0 0 1 23.5 12a11.76389 11.76389 0 0 1-11.75 11.75Z"/>
		<path d="M12 12a.7502.7502 0 0 1-.75-.75V.75a.75.75 0 0 1 1.5 0v10.5A.7502.7502 0 0 1 12 12Z"/>
	</svg>
</template>
